import React from 'react';
import { CArtes } from '../../json/CArtes';
import './cah.css';

const CAH = () => {
  return (
    <div id='cartes_noticias'>
      <div className='row'>
        <div className='col-12'>
          <div className='notice_section'>
            <div className='notice_title'>
              <h3 className='title'>CENTRO DE LAS ARTES DE HIDALGO</h3>
              <hr className='hr-gob'/>
            </div>
            <div className='notice_content'>
              <div id="carouselControls" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                  {
                    CArtes.map((item, index) => (
                      <div key={index} className={index === 0 ? "carousel-item active" : "carousel-item"}>
                        <a href={item.url} target="_blank" rel="noopener noreferrer" className="cah-link">
                          <div
                            className="img-carousel d-block w-100"
                            style={{ backgroundImage: `url("${item.imagen}")` }}
                          >
                            <div className='overlay-gradient'></div>
                            <div className='title_img_carousel1'>
                              <p className='fecha_cah'>{item.fecha}</p>
                              <h6>{item.titulo}</h6>
                              <span className='leer_mas'>Leer más</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    ))
                  }
                </div>

                <button className="carousel-control-prev" type="button" data-bs-target="#carouselControls" data-bs-slide="prev">
                  <span className="control-circle"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselControls" data-bs-slide="next">
                  <span className="control-circle"></span>
                  <span className="visually-hidden">Next</span>
                </button>

                {
                  CArtes.length > 1 &&
                  <div className="carousel-indicators-custom">
                    {
                      CArtes.map((item, index) => (
                        <button
                          key={index}
                          type="button"
                          data-bs-target="#carouselControls"
                          data-bs-slide-to={index}
                          className={index === 0 ? "active" : ""}
                          aria-label={`Slide ${index + 1}`}
                        ></button>
                      ))
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CAH;
